import { useContext } from 'react';
import { AuthenticatedRedirectContext } from '../context/AuthenticatedRedirectContext';
import { AuthenticatedRedirectContextState } from '../model/AuthenticatedRedirectContextState';

export const useAuthenticatedRedirectContext = (): AuthenticatedRedirectContextState =>
  useContext(AuthenticatedRedirectContext);
